import React from "react";
import Cookie from "js-cookie";
const RemoveCookies = (cookieName) => {
  return Cookie.remove(cookieName, { path: "" });
};

export default RemoveCookies;
